export const cilVerticalAlignTop = ["24 24","<path d='M0.75 0.75h22.5v1.5h-22.5v-1.5z'></path><path d='M7.307 9.182l1.061 1.061 2.882-2.882v14.015h1.5v-14.015l2.882 2.882 1.061-1.061-4.693-4.693-4.693 4.693z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-vertical-align-top.js
// module id = null
// module chunks = 